const initialState = {
  personal_terms_accepted: false,
  consent_information_accepted: false,
  housingCompanyPath: "",
  customerSection: true,
  rates: null,
  additionalInsurance: [],
  attachments: [],
  textSections: {
    paymentSelection: [
    ],
    preamble: "",
    securityDoor: true,
    validLocations: [
    ],
    consentInformation: "",
    consentCheckboxInformation: ""
  } 
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_ADDITIONAL_INSURANCE_FROM_API": {
      return Object.assign({}, state, {
        additionalInsurance: action.data
      });
    }

    case "SET_ATTACHMENTS_FROM_API": {
      return Object.assign({}, state, {
        attachments: action.data
      });
    }

    case "SET_HOUSECOMPANY_SUCCESS": {
      return Object.assign({}, state, {
        housingCompanyPath: action.data
      });
    }

    case "UPDATE_CUSTOMER_SECTION": {
      return Object.assign({}, state, {
        customerSection: action.data
      });
    }

    case "SET_PERSONAL_TERMS_ACCEPTED": {
      return Object.assign({}, state, {
        personal_terms_accepted: action.data
      });
    }

    case "ACCEPT_CONSENT_INFORMATION": {
      return Object.assign({}, state, {
        consent_information_accepted: action.data
      })
    }

    case "SET_TEXT_SELECTION": {
      return Object.assign({}, state, {
        textSections: action.data
      })
    }

    default:
      return state;
  }
};
